$(document).ready(function () {
  // Prevent multiple executions of this script
  if (window.primeVocalsPlayerLoaded) return;
  window.primeVocalsPlayerLoaded = true;

  let isAmplitudeInitialized = false;
  let masterPlaylist = [];
  var _masterUrlIndex = {};
  let initTimeout;
  let updateBindingsTimeout;
  let fallbackInitTimeout; // Track the fallback timeout

  // Global Cart State
  window.primeVocalsCartItems = [];

  // Volume fade settings
  let savedVolume = 100;
  let isFading = false;
  const FADE_DURATION = 300; // ms
  const FADE_STEPS = 15;

  // Volume fade out effect
  function fadeOutAndPause() {
    if (isFading) return;
    isFading = true;

    try {
      savedVolume = Amplitude.getVolume() || 100;
      let currentVol = savedVolume;
      const stepSize = currentVol / FADE_STEPS;
      const stepTime = FADE_DURATION / FADE_STEPS;

      const fadeInterval = setInterval(() => {
        currentVol -= stepSize;
        
        if (currentVol <= 0) {
          clearInterval(fadeInterval);
          Amplitude.setVolume(0);
          Amplitude.pause();
          // Restore volume immediately after pause so next play starts normal
          setTimeout(() => {
            Amplitude.setVolume(savedVolume);
            isFading = false;
          }, 50);
        } else {
          Amplitude.setVolume(Math.round(currentVol));
        }
      }, stepTime);
    } catch (e) {
      // Fallback to normal pause
      Amplitude.pause();
      isFading = false;
    }
  }

  // Volume fade in effect
  function fadeInAndPlay() {
    if (isFading) return;
    isFading = true;

    try {
      const targetVolume = savedVolume || 100;
      Amplitude.setVolume(0);
      Amplitude.play();

      let currentVol = 0;
      const stepSize = targetVolume / FADE_STEPS;
      const stepTime = FADE_DURATION / FADE_STEPS;

      const fadeInterval = setInterval(() => {
        currentVol += stepSize;
        
        if (currentVol >= targetVolume) {
          clearInterval(fadeInterval);
          Amplitude.setVolume(targetVolume);
          isFading = false;
        } else {
          Amplitude.setVolume(Math.round(currentVol));
        }
      }, stepTime);
    } catch (e) {
      // Fallback to normal play
      Amplitude.play();
      isFading = false;
    }
  }

  function fetchGlobalCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        window.primeVocalsCartItems = cart.items.map(item => item.variant_id);

        // Dispatch custom event with data for React components
        document.dispatchEvent(new CustomEvent('primevocals:cart-updated', {
          detail: { cartItems: window.primeVocalsCartItems }
        }));

        // Update UI if player is active
        const activeSong = Amplitude.getActiveSongMetadata();
        if (activeSong) {
          updatePlayerUI(activeSong);
        }
      })
      .catch(err => console.error('[AudioPlayer] Error fetching cart:', err));
  }

  // Initial fetch
  fetchGlobalCart();

  // Listen for cart updates
  document.addEventListener('label:modalcart:afteradditem', function () {
    fetchGlobalCart();
  });

  // Also listen for item count updates (triggered when items are removed from cart drawer)
  document.body.addEventListener('label:modalcart:itemcountupdate', function () {
    fetchGlobalCart();
  });

  function updateTracklistWaveform() {}

  function initMasterPlaylist() {
    clearTimeout(initTimeout);
    initTimeout = setTimeout(() => {
      _initMasterPlaylist();
    }, 200);
  }

  function _initMasterPlaylist() {
    // 1. Get Hero Tracks AND Recommendation Tracks (from DOM) - NOW ALL TRACKS
    const heroSongs = [];
    $('.custom-audio-player-play-pause-grid').each(function () {
      const $btn = $(this);
      heroSongs.push({
        "name": $btn.data('product-title'),
        "artist": "Prime Vocals",
        "album": $btn.data('product-vendor'),
        "url": ($btn.data('audio-url') || "").replace(/^http:/, 'https:'),
        "cover_art_url": $btn.closest('.group').find('img').attr('src') || "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081",
        "id": $btn.data('product-id'),
        "bpm": $btn.data('bpm'),
        "key": $btn.data('key'),
        "price": $btn.data('price'), // Capture price
        "product_url": $btn.attr('data-product-url'),
        "vendor_handle": $btn.attr('data-vendor-handle'),
        "collection_title": $btn.attr('data-collection-title'),
        "collection_handle": $btn.attr('data-collection-handle')
      });
    });

    // 2. Get Track Browser Tracks (from global window object)
    const browserSongs = window.primeVocalsAllProducts || [];

    // 3. Combine unique songs
    // Use a Map to deduplicate by URL.
    const songMap = new Map();

    // Merge helper: never clobber an existing non-empty field with an empty
    // one. The hero carousel buttons (rendered by React) only expose audio /
    // id / title and are missing product_url + vendor_handle, while the track
    // browser list has them. A plain overwrite would wipe product_url, leaving
    // the player title pointing at "#" instead of the real product page.
    const isEmpty = v => v === undefined || v === null || v === '';
    const upsertSong = song => {
      const existing = songMap.get(song.url);
      if (!existing) {
        songMap.set(song.url, Object.assign({}, song));
        return;
      }
      Object.keys(song).forEach(k => {
        if (isEmpty(existing[k]) && !isEmpty(song[k])) {
          existing[k] = song[k];
        }
      });
    };

    // If we already have a master playlist, start with it to preserve order/state
    if (masterPlaylist.length > 0) {
      masterPlaylist.forEach(upsertSong);
    }

    // Add new songs (Hero + Browser)
    // IMPORTANT: Add browserSongs FIRST to preserve the order of the main list.
    // Hero songs are often duplicates or featured tracks; we want the main list's order to be the source of truth.
    browserSongs.forEach(upsertSong);
    heroSongs.forEach(upsertSong);

    const newMasterPlaylist = Array.from(songMap.values());

    if (newMasterPlaylist.length === 0) return;

    console.log('[AudioPlayer] Updating Master Playlist. Total songs: ' + newMasterPlaylist.length);

    masterPlaylist = newMasterPlaylist;
    _masterUrlIndex = {};
    for (var _mi = 0; _mi < masterPlaylist.length; _mi++) {
      _masterUrlIndex[masterPlaylist[_mi].url] = _mi;
    }

    // 4. If Amplitude is ALREADY initialized, just add new songs and update bindings
    if (isAmplitudeInitialized) {
      // We need to sync Amplitude's internal playlist with our new master playlist
      // Amplitude 5.2 doesn't have a simple "setSongs" that preserves playback easily without re-init.
      // However, we can use addSong for new ones.

      const currentAmplitudeSongs = Amplitude.getSongs();
      const currentUrls = new Set(currentAmplitudeSongs.map(s => s.url));

      masterPlaylist.forEach(song => {
        if (!currentUrls.has(song.url)) {
          Amplitude.addSong(song);
        }
      });

      // Update bindings for the new DOM elements
      updateButtonBindings();
      return;
    }

    // 5. First Time Initialization
    console.log('[AudioPlayer] First time initialization.');

    // AGGRESSIVE CLEANUP: Stop and remove ALL audio elements to prevent duplicates
    $('audio').each(function () {
      try {
        this.pause();
        this.currentTime = 0;
        this.src = '';
        $(this).remove(); // Remove from DOM entirely
      } catch (e) {
        console.error('[AudioPlayer] Error cleaning up audio element:', e);
      }
    });

    var _cachedProgressBar = null;
    var _cachedCurrentTime = null;
    var _cachedDurationTime = null;
    var _lastFormattedSec = '';
    var _lastFormattedDur = '';
    var _tuFormatTime = function(s) {
      var min = Math.floor(s / 60);
      var sec = Math.floor(s % 60);
      return (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
    };

    Amplitude.init({
      "songs": masterPlaylist,
      "preload": "none",
      "callbacks": {
        'timeupdate': function () {
          const songPlayedPercentage = Amplitude.getSongPlayedPercentage();

          updateTracklistWaveform(songPlayedPercentage);

          if (!_cachedProgressBar) _cachedProgressBar = document.getElementById('song-played-progress-1');
          if (_cachedProgressBar) {
            _cachedProgressBar.style.width = songPlayedPercentage + '%';
          }

          const activeSong = Amplitude.getActiveSongMetadata();
          if (activeSong) {
            var fSec = _tuFormatTime(Amplitude.getSongPlayedSeconds());
            var fDur = _tuFormatTime(Amplitude.getSongDuration());
            if (fSec !== _lastFormattedSec) {
              _lastFormattedSec = fSec;
              if (!_cachedCurrentTime) _cachedCurrentTime = document.querySelector('.amplitude-current-time');
              if (_cachedCurrentTime) _cachedCurrentTime.textContent = fSec;
            }
            if (fDur !== _lastFormattedDur) {
              _lastFormattedDur = fDur;
              if (!_cachedDurationTime) _cachedDurationTime = document.querySelector('.amplitude-duration-time');
              if (_cachedDurationTime) _cachedDurationTime.textContent = fDur;
            }
          }
        },
        'song_change': function () {
          const activeSong = Amplitude.getActiveSongMetadata();
          if (!activeSong) return;

          updatePlayerUI(activeSong);
          // savePlayerState(); // Removed as per previous revert or missing function

          // Sync TrackBrowser Pagination
          // This ensures that if the song changes to one on a different page, the list updates.
          // Skipped when playback was just started from the hero carousel, so the
          // track list doesn't jump to the pressed track.
          var fromHeroCarousel = Date.now() - (window._pvHeroPlayTs || 0) < 1500;
          if (activeSong && activeSong.id && !fromHeroCarousel) {
            document.dispatchEvent(new CustomEvent('primevocals:locate-track', {
              detail: { variantId: activeSong.id }
            }));
          }

          document.dispatchEvent(new CustomEvent('primevocals:player-song-change', { detail: { activeSong } }));
        },
        'play': function () {
          const activeSong = Amplitude.getActiveSongMetadata();
          if (activeSong) {
            syncPlayButtons(activeSong.url, true);
            $('.amplitude-play-pause').removeClass('amplitude-paused').addClass('amplitude-playing');
            // Show player when playback starts
            $('#custom-audio-player').addClass("display-block");

            // Increment Play Count (Debounced per song session)
            if (window.lastCountedSongId !== activeSong.id) {
              window.lastCountedSongId = activeSong.id;
              incrementPlayCount(activeSong.id);
            }

            document.dispatchEvent(new CustomEvent('primevocals:player-play', { detail: { activeSong } }));
          }
        },
        'pause': function () {
          const activeSong = Amplitude.getActiveSongMetadata();
          if (activeSong) {
            syncPlayButtons(activeSong.url, false);
            $('.amplitude-play-pause').removeClass('amplitude-playing').addClass('amplitude-paused');

            document.dispatchEvent(new CustomEvent('primevocals:player-pause', { detail: { activeSong } }));
          }
        }
      }
    });

    isAmplitudeInitialized = true;
    Amplitude.setVolume(100);

    // Initial binding update
    updateButtonBindings();

    // Keep the now-playing highlight resilient to React re-renders (swipe etc.)
    startHighlightObserver();
  }

  function updateButtonBindings() {
    clearTimeout(updateBindingsTimeout);
    updateBindingsTimeout = setTimeout(() => {
      _updateButtonBindings();
    }, 50);
  }

  function _updateButtonBindings() {
    var btns = document.querySelectorAll('.custom-audio-player-play-pause-grid');
    for (var _bi = 0; _bi < btns.length; _bi++) {
      var url = btns[_bi].getAttribute('data-audio-url');
      var idx = _masterUrlIndex[url];
      if (idx !== undefined) {
        btns[_bi].setAttribute('data-amplitude-song-index', idx);
      }
    }

    // Also sync the play/pause state of the buttons
    const activeSong = Amplitude.getActiveSongMetadata();
    const isPlaying = Amplitude.getPlayerState() === 'playing';
    if (activeSong) {
      syncPlayButtons(activeSong.url, isPlaying);
    }
  }

  // Note: syncPlayButtons is defined later in the file (line ~452) with URL-based matching
  // This duplicate was removed to prevent function overwriting

  // Listen for Master List Ready (from React)
  document.addEventListener('primevocals:master-list-ready', function () {
    clearTimeout(fallbackInitTimeout); // React is ready, cancel fallback
    initMasterPlaylist();
  });

  // Listen for UI Updates (Filtering/Searching)
  document.addEventListener('primevocals:track-browser-updated', function () {
    // Just update bindings, DO NOT re-init Amplitude
    updateButtonBindings();
  });

  // Listen for Cart Updates (Instant UI)
  document.addEventListener('primevocals:cart-updated', function () {
    const activeSong = Amplitude.getActiveSongMetadata();
    if (activeSong) {
      updatePlayerUI(activeSong);
    }
  });

  // Mutation Observer to handle React re-renders — scoped to track browser root
  var _observerDebounce = null;
  const observer = new MutationObserver(function () {
    if (_observerDebounce) return;
    _observerDebounce = setTimeout(function () {
      _observerDebounce = null;
      updateButtonBindings();
    }, 200);
  });

  var tbRoot = document.querySelector('.react-track-browser-root');
  if (tbRoot) {
    observer.observe(tbRoot, { childList: true, subtree: true });
  } else {
    var _tbPoll = setInterval(function () {
      var el = document.querySelector('.react-track-browser-root');
      if (el) {
        clearInterval(_tbPoll);
        observer.observe(el, { childList: true, subtree: true });
      }
    }, 500);
  }

  // Fallback init on load (for Hero if React is slow or fails)
  fallbackInitTimeout = setTimeout(initMasterPlaylist, 1000);





  // Helper to increment play count
  function incrementPlayCount(variantId) {
    if (!variantId) return;

    // Use the proxy URL
    fetch('/apps/seller-portal-custom/products/increment-play-count', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ variantId: variantId })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          console.log(`[AudioPlayer] Incremented play count for ${variantId}. New count: ${data.play_count}`);
        } else {
          console.warn('[AudioPlayer] Failed to increment play count:', data.error);
        }
      })
      .catch(err => console.error('[AudioPlayer] Error incrementing play count:', err));
  }

  // Helper to update UI
  function updatePlayerUI(activeSong) {
    if (!activeSong) return;

    // The active song metadata can be a "hero" entry that lacks product_url /
    // vendor_handle. Backfill those from the merged master playlist (matched by
    // audio URL) so the title always links to the real product page.
    if (!activeSong.product_url || !activeSong.vendor_handle) {
      const normalize = u => (u || '').replace(/^http:/, 'https:');
      const target = normalize(activeSong.url);
      const richer = masterPlaylist.find(s => normalize(s.url) === target);
      if (richer) {
        if (!activeSong.product_url && richer.product_url) activeSong.product_url = richer.product_url;
        if (!activeSong.vendor_handle && richer.vendor_handle) activeSong.vendor_handle = richer.vendor_handle;
      }
    }

    $('.custom-audio-player-title').text(activeSong.name).attr('href', activeSong.product_url || '#');

    const vendorUrl = activeSong.vendor_handle
      ? `/collections/${activeSong.vendor_handle}`
      : `/collections/vendors?q=${encodeURIComponent(activeSong.album)}`;
    $('.custom-audio-player-vendor').text(activeSong.album).attr('href', vendorUrl);

    $('.custom-audio-player-bpm').text(activeSong.bpm);
    $('.custom-audio-player-keynote').text(activeSong.key);
    $('.custom-audio-player-cover').attr('src', activeSong.cover_art_url).show();
    $('.custom-audio-player-add-to-cart').attr('data-variant-id', activeSong.id);

    // Reset Add to Cart button state
    const addToCartBtn = $('.custom-audio-player-add-to-cart');
    const variantId = parseInt(activeSong.id);
    const isInCart = window.primeVocalsCartItems.includes(variantId);

    if (isInCart) {
      addToCartBtn.addClass('in-cart');
      addToCartBtn.html(`
        <span class="state-normal" style="display: flex; align-items: center; gap: 6px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Added
        </span>
        <span class="state-hover" style="display: none; align-items: center; gap: 6px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          Added
        </span>
      `).prop('disabled', false);
    } else {
      addToCartBtn.removeClass('in-cart');
      // Use HTML to include price and icon
      const priceHtml = activeSong.price ? `<span>${activeSong.price}</span>` : '';
      // Lucide ShoppingCart icon SVG
      const cartIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>`;
      addToCartBtn.html(`${priceHtml} ${cartIcon}`).prop('disabled', false);
    }

    // Update Grid Buttons (Sync UI)
    const isPlaying = Amplitude.getPlayerState() === 'playing';
    syncPlayButtons(activeSong.url, isPlaying);

    // Show Player logic moved to 'play' callback to prevent auto-open on load
  }

  function syncPlayButtons(activeUrl, isPlaying) {
    if (isPlaying === undefined) isPlaying = true;
    // Only clear the grid buttons this function manages. A global
    // `.is-playing` query would also strip the class from the mobile audio
    // player's play/pause button, leaving it stuck on the "play" (triangle) icon.
    var prevActive = document.querySelectorAll('.custom-audio-player-play-pause-grid.is-playing');
    for (var _pi = 0; _pi < prevActive.length; _pi++) prevActive[_pi].classList.remove('is-playing');
    var prevTracks = document.querySelectorAll('.is-active-track');
    for (var _pt = 0; _pt < prevTracks.length; _pt++) prevTracks[_pt].classList.remove('is-active-track');

    if (!activeUrl) return;
    var normalizedActiveUrl = (activeUrl || '').replace(/^http:/, 'https:');

    var allBtns = document.querySelectorAll('.custom-audio-player-play-pause-grid');
    for (var _si = 0; _si < allBtns.length; _si++) {
      var btnUrl = (allBtns[_si].getAttribute('data-audio-url') || '').replace(/^http:/, 'https:');
      if (btnUrl === normalizedActiveUrl && isPlaying) {
        allBtns[_si].classList.add('is-playing');
        var container = allBtns[_si].closest('.track-browser-item, .custom-audio-player-grid-item, .premium-card');
        if (container) container.classList.add('is-active-track');
      }
    }
  }

  // ---------------------------------------------------------------------------
  // Keep the "now playing" highlight alive across React re-renders.
  //
  // The track list is a React island, but the `is-playing` / `is-active-track`
  // classes above are added imperatively (React doesn't know about them).
  // Whenever React re-renders a row — most visibly while the user swipes the
  // list, but also on pagination/filtering — it rewrites that element's
  // className from its own virtual DOM and silently drops our classes, so the
  // highlight disappears until the next play/pause. Re-apply it whenever the
  // list DOM mutates so the highlight tracks the React-controlled markup.
  // ---------------------------------------------------------------------------
  function reapplyActiveHighlight() {
    if (!isAmplitudeInitialized || typeof Amplitude === 'undefined') return;
    var activeSong = Amplitude.getActiveSongMetadata();
    if (!activeSong) return;
    syncPlayButtons(activeSong.url, Amplitude.getPlayerState() === 'playing');
  }

  var _highlightObserver = null;
  var _highlightRaf = 0;

  function _observeHighlightTargets() {
    if (!_highlightObserver) return;
    _highlightObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function startHighlightObserver() {
    if (_highlightObserver || typeof MutationObserver === 'undefined' || !document.body) return;
    _highlightObserver = new MutationObserver(function () {
      // Coalesce bursts of mutations (e.g. a swipe re-render) into one pass.
      if (_highlightRaf) return;
      _highlightRaf = requestAnimationFrame(function () {
        _highlightRaf = 0;
        // Detach while we mutate so our own class changes don't re-trigger us.
        _highlightObserver.disconnect();
        reapplyActiveHighlight();
        _observeHighlightTargets();
      });
    });
    _observeHighlightTargets();
  }

  // Handle Grid Click - Just play the index
  $(document).off('click', '.custom-audio-player-play-pause-grid').on('click', '.custom-audio-player-play-pause-grid', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Stop bubbling to prevent any other handlers
    e.stopImmediatePropagation(); // Ensure no other handlers on this element run

    console.log('[AudioPlayer] Play button clicked');

    // Resolve the song index straight from the attribute. We deliberately do
    // NOT use jQuery's $(this).data() here: .data() caches the value on first
    // read, so if the click lands before the master playlist has assigned
    // data-amplitude-song-index (which happens asynchronously after a Turbo
    // navigation re-mounts the list), jQuery caches `undefined` and keeps
    // returning it even after setAttribute() later writes the real index —
    // leaving that button permanently "unclickable". Reading the attribute
    // (with a URL-based fallback) avoids that stale cache entirely.
    var rawIndex = this.getAttribute('data-amplitude-song-index');
    var index = rawIndex !== null && rawIndex !== '' ? parseInt(rawIndex, 10) : NaN;

    if (isNaN(index)) {
      // Not indexed yet — resolve from the button's audio URL via the master
      // playlist map. Re-run the binding pass once in case the list was just
      // re-mounted, then look the URL up again before giving up.
      var audioUrl = this.getAttribute('data-audio-url');
      var resolved = audioUrl != null ? _masterUrlIndex[audioUrl] : undefined;
      if (resolved === undefined) {
        _updateButtonBindings();
        resolved = audioUrl != null ? _masterUrlIndex[audioUrl] : undefined;
      }
      if (resolved === undefined) {
        console.warn('[AudioPlayer] No song index found for clicked element');
        return;
      }
      index = resolved;
      this.setAttribute('data-amplitude-song-index', index);
    }

    // If clicking the currently playing song, toggle play/pause
    const activeIndex = Amplitude.getActiveIndex();
    const playerState = Amplitude.getPlayerState();

    console.log(`[AudioPlayer] Clicked Index: ${index}, Active Index: ${activeIndex}, State: ${playerState}`);

    if (activeIndex == index) {
      // Ensure UI is updated even if song didn't change (e.g. first play)
      const song = masterPlaylist[index];
      if (song) updatePlayerUI(song);

      if (playerState === 'playing') {
        fadeOutAndPause();
      } else {
        fadeInAndPlay();
      }
    } else {
      // New song - fade in from start
      if (isFading) return; // Prevent race conditions
      isFading = true;
      
      const currentSavedVolume = savedVolume || Amplitude.getVolume() || 100;
      Amplitude.setVolume(0);
      Amplitude.playSongAtIndex(index);
      
      // Fade in
      let currentVol = 0;
      const targetVolume = currentSavedVolume;
      const stepSize = targetVolume / FADE_STEPS;
      const stepTime = FADE_DURATION / FADE_STEPS;
      
      const fadeInterval = setInterval(() => {
        currentVol += stepSize;
        if (currentVol >= targetVolume) {
          clearInterval(fadeInterval);
          Amplitude.setVolume(targetVolume);
          isFading = false;
        } else {
          Amplitude.setVolume(Math.round(currentVol));
        }
      }, stepTime);
    }

    $('#custom-audio-player').addClass("display-block");
  });

  // End New
  $('.custom-audio-player-close').on('click', function () {
    // Fade out then hide
    if (Amplitude.getPlayerState() === 'playing') {
      fadeOutAndPause();
      setTimeout(() => {
        $('#custom-audio-player').removeClass("display-block");
      }, FADE_DURATION + 50);
    } else {
      $('#custom-audio-player').removeClass("display-block");
    }
  });
  $(document).on('click', '.progress-container', function (e) {
    // Get the total width of the progress container
    const totalWidth = $(this).width();

    // Calculate the click position relative to the progress container
    const clickPosition = e.pageX - $(this).offset().left;

    // Calculate the percentage of the click position within the progress bar
    const percentage = (clickPosition / totalWidth) * 100;

    // Get the active song index
    const activeIndex = Amplitude.getActiveIndex();

    // Set the song's played percentage based on the calculated percentage for the active song
    Amplitude.setSongPlayedPercentage(percentage, activeIndex);
  });
  $('.amplitude-volume-slider').on('input', function () {
    var volumeValue = parseInt($(this).val()); // Get the current value of the volume slider
    Amplitude.setVolume(volumeValue); // Update Amplitude volume based on the slider value (between 0 and 100)
    
    // Update savedVolume so fade uses correct value
    if (volumeValue > 0) {
      savedVolume = volumeValue;
    }

    // Update icon based on volume
    if (volumeValue == 0) {
      $('.volume-icon').removeClass('fa-volume-high').addClass('fa-volume-xmark');
    } else {
      $('.volume-icon').removeClass('fa-volume-xmark').addClass('fa-volume-high');
    }
  });

  // Mute Toggle
  $('.volume-icon').on('click', function () {
    const currentVolume = Amplitude.getVolume();
    if (currentVolume > 0) {
      // Mute - save volume before muting
      savedVolume = currentVolume;
      $(this).data('prev-volume', currentVolume);
      Amplitude.setVolume(0);
      $('.amplitude-volume-slider').val(0);
      $(this).removeClass('fa-volume-high').addClass('fa-volume-xmark');
    } else {
      // Unmute - restore saved volume
      const prevVolume = $(this).data('prev-volume') || savedVolume || 50;
      Amplitude.setVolume(prevVolume);
      savedVolume = prevVolume;
      $('.amplitude-volume-slider').val(prevVolume);
      $(this).removeClass('fa-volume-xmark').addClass('fa-volume-high');
    }
  });

  // Button to open/close the volume control
  $('.custom-audio-player-volume-open').on('click', function () {
    $('.custom-audio-player-volume-slider-wrapper').toggleClass('display-none'); // Toggle display of the volume slider
  });

  // Spacebar Play/Pause Toggle
  $(document).on('keydown', function (e) {
    // Check if spacebar (keyCode 32) is pressed
    if (e.keyCode === 32) {
      // Ignore if user is typing in an input, textarea, or contenteditable
      if ($(e.target).is('input, textarea, [contenteditable]')) {
        return;
      }

      // User Request: On home page, space bar should not initiate play start (and thus not hijack scroll)
      // unless the player is already generated/visible.
      const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index';
      const isPlayerVisible = $('#custom-audio-player').hasClass('display-block');

      if (isHomePage && !isPlayerVisible) {
        return; // Allow default behavior (scrolling)
      }

      e.preventDefault(); // Prevent page scrolling ALWAYS if not typing (and not returned above)

      // Only toggle if the player is visible/active (optional, but good UX)
      // Or just check if there is an active song
      const activeSong = Amplitude.getActiveSongMetadata();
      if (activeSong && !isFading) {
        if (Amplitude.getPlayerState() === 'playing') {
          fadeOutAndPause();
        } else {
          fadeInAndPlay();
        }
      }
    }
  });

  // Locator Dot Logic (Home Page Only)
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index';
  if (isHomePage) {
    $('.custom-audio-player-locator').show();

    $('.custom-audio-player-locator').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const activeSong = Amplitude.getActiveSongMetadata();
      if (activeSong && activeSong.id) {
        // Automatic Helper: Position the tracks list (container) in view
        const $trackBrowser = $('#track-browser');
        if ($trackBrowser.length > 0) {
          // Scroll to the top of the track browser with an offset for the header
          const headerOffset = 100; // Adjust based on your header height
          const elementPosition = $trackBrowser.offset().top;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }

        // Dispatch event for TrackBrowser to handle pagination (but NOT scroll to item)
        document.dispatchEvent(new CustomEvent('primevocals:locate-track', {
          detail: { variantId: activeSong.id }
        }));
      }
    });
  }

});

customElements.define("custom-audio-player",
  class CustomAudioPlayer extends HTMLElement {
    constructor() {
      super();
      this.addToCart = this.addToCart.bind(this);
      this.addToCartButton = this.querySelector(".custom-audio-player-add-to-cart")

      this.cartItems = []
      this.setupEventListeners()
    }
    setupEventListeners() {
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener("click", this.addToCart)
      }
    }

    addToCart(event) {
      const button = event.target.closest('.custom-audio-player-add-to-cart');
      if (!button) return;

      const variantId = parseInt(button.dataset.variantId);
      const wasInCart = window.primeVocalsCartItems.includes(variantId);

      // 1. Optimistic Update
      if (wasInCart) {
        window.primeVocalsCartItems = window.primeVocalsCartItems.filter(id => id !== variantId);
      } else {
        window.primeVocalsCartItems = [...window.primeVocalsCartItems, variantId];
      }

      // 2. Dispatch Event to update UI immediately (including this player's UI via the listener)
      document.dispatchEvent(new CustomEvent('primevocals:cart-updated', {
        detail: { cartItems: window.primeVocalsCartItems }
      }));

      // Also trigger the theme's event so other things might update if they listen to it
      // But we pass openDrawer: false to avoid annoying popups
      document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem', { detail: { openDrawer: false } }));

      // 3. Perform Network Request
      if (wasInCart) {
        // Remove
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: 0 })
        })
          .then(res => {
            if (!res.ok) throw new Error('Failed to remove');
          })
          .catch(err => {
            console.error('Error removing from cart:', err);
            // Rollback
            window.primeVocalsCartItems.push(variantId);
            document.dispatchEvent(new CustomEvent('primevocals:cart-updated', {
              detail: { cartItems: window.primeVocalsCartItems }
            }));
          });
      } else {
        // Add
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(res => {
            if (!res.ok) throw new Error('Failed to add');
          })
          .catch(err => {
            console.error('Error adding to cart:', err);
            // Rollback
            window.primeVocalsCartItems = window.primeVocalsCartItems.filter(id => id !== variantId);
            document.dispatchEvent(new CustomEvent('primevocals:cart-updated', {
              detail: { cartItems: window.primeVocalsCartItems }
            }));
          });
      }
    }

    checkCart(key) {
      // Deprecated in favor of global fetchGlobalCart
    }
    // ... Add the rest of the audio player methods from the previous implementation ...
  }
);
